















































































import Vue from 'vue';
export default Vue.extend({
  name: 'AccountModalBase',
  props: {
    title: String,
  },
});
